// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  // appUrl: 'http://pentagon-uat.connectie-t.com:2231/api/v1/'
  // appUrl: 'http://ptal-service-uat.connectie-t.com:8080/api/v1/'
  appUrl: 'https://admin.ptal.com.hk:8443/api/v1/'
};



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/environments/environment.ts